





























































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NavigationTabs extends Vue {
  @Prop() readonly eventId!: string;

  private isActiveTab(tab: string): boolean {
    return this.$route.name == tab;
  }
}
